import { API_REQUEST } from 'utils/API/constants'

export const API_ANALYTICS = 'api-analytics'

export const ACTIONS_ACTIVE_ANALYTICS = {
  [API_ANALYTICS]: 'ANALYTICS',
  [API_REQUEST]: 'REQUEST'
}
